import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Adaugă manager',
    first_name: {
      label: 'Prenume',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Nume de familie',
      placeholder: 'White',
    },
    city: {
      label: 'Oraș',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Email',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rol',
      placeholder: 'Selectați rolul',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Proprietar',
      options: {
        [ManagerRole.Admin]: 'Administrator',
        [ManagerRole.Reseller]: 'Reseller',
        [ManagerRole.SalesManager]: 'Manager vânzări',
        [ManagerRole.SalesLeadership]: 'Lider vânzări',
        [ManagerRole.ContentManager]: 'Manager conținut',
        [ManagerRole.OnboardingManager]: 'Manager onboarding',
        [ManagerRole.MobileAppsManager]: 'Manager aplicații mobile',
        [ManagerRole.StoreAdmin]: 'Administrator',
        [ManagerRole.StoreEmployee]: 'Angajat',
        [ManagerRole.StoreOperator]: 'Operator',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operator:</strong> Acces complet la Vânzări, Meniu, Articole de top, Program, Carduri cadou, Rezervări și Rapoarte pentru companiile atribuite.',
        [ManagerRole.StoreEmployee]: '<strong>Angajat:</strong> Acces limitat doar la Rezervări și Carduri cadou.',
        [ManagerRole.StoreAdmin]:
          '<strong>Proprietar:</strong> Acces complet la un restaurant, inclusiv magazin online, setări taxe, marketing și gestionarea echipei. Primește un email cu datele de autentificare. Un singur proprietar per restaurant, iar ceilalți membri ai echipei nu îl pot edita sau elimina.',
      },
    },
    companies: {
      label: 'Companii',
      placeholder: 'Selectați companiile',
      owner_placeholder: 'Selectați restaurantul',
      has_owner: 'Are un proprietar',
    },
  },
  fields: {
    email: 'Email',
    name: 'Nume',
    roles: 'Rol',
    created_at: 'Creat',
    actions: 'Acțiuni',
    companies: 'Companii',
    status: 'Stare',
  },
  tags: {
    owner: 'Proprietar',
    operator: 'Operator',
    employee: 'Angajat',
  },
  no_owner: {
    title: '{{restaurant}} nu are proprietar',
    description: 'Tot ce necesită proprietarul așteaptă până se alege unul.',
  },
  search: {
    placeholder: 'Căutați după nume sau email',
  },
  buttons: {
    add_manager: 'Adaugă manager',
    actions: 'Acțiuni',
    view_dashboard: 'Vizualizați panoul ca acest manager',
    login_as_manager: 'Conectați-vă ca acest manager',
    delete: 'Ștergeți acest manager',
    resend_owner_invite: 'Retrimite invitația proprietarului',
    save_companies: 'Salvează restaurantele lui {{name}}',
    change_owner: 'Elimină pe {{name}} din rolul de proprietar',
    delete_named: 'Șterge pe {{name}}',
    choose_owner: 'Alege un proprietar',
  },
  modals: {
    delete_manager: {
      title: 'Sigur doriți să ștergeți managerul {{email}}?',
    },
    update_manager: {
      title: 'Sigur doriți să actualizați managerul {{email}}?',
    },
    resend_owner_invite: {
      title: 'Retrimiți invitația către {{email}}?',
      description: 'Proprietarul primește o parolă nouă prin e-mail. Parola actuală nu va mai funcționa.',
    },
  },
  toasts: {
    successfully_created_manager: 'Managerul a fost creat cu succes',
    owner_invited:
      '{{email}} a fost invitat ca proprietar al restaurantului și va primi datele de conectare prin e-mail.',
    failed_to_load_data: 'Nu s-au putut încărca datele, vă rugăm reîmprospătați pagina',
    failed_to_create_manager: 'Nu s-a putut crea managerul',
    failed_to_create_magic_link: 'Nu s-a putut crea link-ul magic',
    failed_to_delete_manager: 'Nu s-a putut șterge managerul',
    manager_got_deleted: 'Managerul a fost șters',
    successfully_updated_manager: 'Managerul a fost actualizat',
    failed_to_update_manager: 'Nu s-a putut actualiza managerul',
    owner_invite_resent: 'Invitația a fost trimisă din nou către {{email}}, cu o parolă nouă.',
    owner_invite_resend_cooling_down:
      'Invitația tocmai a fost retrimisă. Așteptați câteva minute înainte de a o trimite din nou.',
    failed_to_resend_owner_invite: 'Retrimiterea invitației a eșuat',
    owner_changed: '{{name}} este acum proprietar',
    owner_changed_new: '{{name}} este acum proprietar. Datele de autentificare au fost trimise la {{email}}',
    owner_removed: '{{name}} nu mai este proprietar',
  },
};
